import { dataCellphoneSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCellphoneSolid = /*#__PURE__*/createIcon(dataCellphoneSolid)
export default IconCellphoneSolid
